<template lang="pug">
#select-laudo
    p(v-if='tipos.length > 1') {{ $t('laudos.selecioneTipoDeLaudo') }}
    el-select(
        v-if='tipos.length > 1',
        v-model='laudoSelecionado',
        :placeholder='$t("laudos.selecioneTipoDeLaudo")',
        @change='mudarLaudo'
    )
        el-option(
            v-for='tipo in tipos',
            :key='tipo.id',
            :label='tipo.nome',
            :value='tipo.id'
        )
</template>

<script>
import LaudoEmpresaService from '@/modules/laudos/services/LaudoEmpresaService';
import { mapGetters } from 'vuex';
import EventBus from '@/utils/eventBus';
import { orderBy } from 'lodash';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';

const laudos = [
    { id: 99, nomeComponent: 'LaudoGeralModal' },
    { id: TipoLaudo.AGRICOLA, nomeComponent: 'LaudoAgricolaModal' },
    {
        id: TipoLaudo.BACEN_FISCALIZACAO,
        nomeComponent: 'LaudoBacenFiscalizacaoModal'
    },
    { id: TipoLaudo.BENFEITORIAS, nomeComponent: 'LaudoBenfeitoriasModal' },
    {
        id: TipoLaudo.CONFORMIDADE,
        nomeComponent: 'LaudoConformidadeAmbientalModal'
    },
    { id: TipoLaudo.CARBONO, nomeComponent: 'LaudoCarbonoModal' },
    {
        id: TipoLaudo.HISTORICO_AGRICOLA,
        nomeComponent: 'LaudoHistoricoAgricolaModal'
    },
    {
        id: TipoLaudo.DIAGNOSTICO_AGRICOLA,
        nomeComponent: 'LaudoDiagnosticoAgricolaModal'
    },
    {
        id: TipoLaudo.SUPRESSAO_VEGETAL,
        nomeComponent: 'LaudoSupressaoVegetalModal'
    },
    {
        id: TipoLaudo.TECNICO_AGRICOLA,
        nomeComponent: 'LaudoTecnicoAgricolaModal'
    },
    { id: TipoLaudo.CROQUI_LOCALIZACAO, nomeComponent: 'LaudoCroquiModal' },
    { id: TipoLaudo.BACEN_140, nomeComponent: 'LaudoBacenResolucao140Modal' },
    {
        id: TipoLaudo.AVALIACAO_FUNDIARIA,
        nomeComponent: 'LaudoAvaliacaoFundiariasModal'
    },
    {
        id: TipoLaudo.AVALIACAO_DE_AREA_PRODUTIVA,
        nomeComponent: 'LaudoAvaliacaoAreaProdutivaModal'
    },
    {
        id: TipoLaudo.AVALIACAO_SOCIOAMBIENTAL,
        nomeComponent: 'LaudoAvaliacaoSocioambientalModal'
    },
    {
        id: TipoLaudo.DINAMICA_EXPLORACAO,
        nomeComponent: 'LaudoDinamicaExploracaoModal'
    },
    { id: TipoLaudo.RENOVABIO, nomeComponent: 'LaudoRenovabioModal' },
    {
        id: TipoLaudo.RELATORIO_TERRITORIAL,
        nomeComponent: 'LaudoRelatorioTerritorialModal'
    },
    {
        id: TipoLaudo.ANALISE_DE_COBERTURA_DE_SOLO,
        nomeComponent: 'LaudoAnaliseCoberturaSoloModal'
    },
    {
        id: TipoLaudo.SUPRESSAO_VEGETAL_RED_YELLOW_FLAG,
        nomeComponent: 'LaudoSupressaoVegetalRedYellowFlagModal'
    }
];

export default {
    name: 'SelecionarLaudo',

    emits: ['laudoUnico'],

    props: {
        laudoId: {
            type: Number
        }
    },

    data() {
        return {
            tipos: [],
            laudoSelecionado: null
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado'])
    },

    methods: {
        async getTipoLaudo() {
            try {
                const idGrupo = this.usuarioLogado.idGrupo;
                const response = await LaudoEmpresaService.buscarTiposLaudo(idGrupo);
                this.tipos = response.data.itens;
                this.tipos = orderBy(this.tipos, ['nome']);
                this.$emit(
                    'laudoUnico',
                    this.tipos.length > 1 ? 'false' : 'true'
                );
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'laudos.erro.ocorreuUmerroAoBuscarTiposDeLaudo'
                    )
                });
            }
            if (this.laudoId && this.laudoId !== 99) {
                this.laudoSelecionado = this.laudoId;
                const route = laudos.find(r => r.id === this.laudoSelecionado);
                this.$emit('nomeComponenteSelecionado', route.nomeComponent);
            } else if (this.laudoId === 99) {
                this.laudoSelecionado = 99;
                this.tipos.unshift({
                    codigo: 'VAZIO',
                    id: 99,
                    nome: 'Selecione'
                });
                const route = laudos.find(r => r.id === this.laudoSelecionado);
                this.$emit('nomeComponenteSelecionado', route.nomeComponent);
            } else {
                const route = laudos.find(r => r.id === this.laudoSelecionado);
                this.laudoSelecionado = route.id;
                this.$emit('nomeComponenteSelecionado', route.nomeComponent);
            }
        },

        mudarLaudo() {
            this.tipos = this.tipos.filter(tipo => tipo.id !== 99);
            const route = laudos.find(r => r.id === this.laudoSelecionado);
            this.$emit('nomeComponenteSelecionado', route.nomeComponent);
            EventBus.$emit('laudo-selecionado', this.laudoSelecionado);
        }
    },
    async mounted() {
        await this.getTipoLaudo();
    },
    watch: {
        laudoId() {
            this.laudoSelecionado = this.laudoId;
            const route = laudos.find(r => r.id === this.laudoSelecionado);
            this.$emit('nomeComponenteSelecionado', route.nomeComponent);
        }
    }
};
</script>

<style scoped lang="scss">
#select-laudo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;

    .el-select {
        width: 50%;
    }
}
</style>
